import React, { memo } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { IMG_CDN_URL } from '@constants';
import { socialNetworksLinks } from './constants';

import styles from './styles/index.module.scss';

const SocialMedia = memo(({ platform }) => (
  <div className={styles.links}>
    {socialNetworksLinks[platform].map(({ id, dataQa, href, name }) => (
      <a
        key={id}
        className={styles.link}
        href={href}
        rel="noopener noreferrer"
        target="_blank"
        aria-label={name}
        data-qa={dataQa}
      >
        <i
          className={cn(styles.linkIcon, styles[`linkIcon${name}`])}
          data-src={`${IMG_CDN_URL}/svg/social-media/${id}.svg`}
          data-was-processed="true"
        />
      </a>
    ))}
  </div>
));

SocialMedia.propTypes = {
  platform: PropTypes.string.isRequired,
};

SocialMedia.displayName = 'SocialMedia';

export default SocialMedia;
